import React, { useEffect } from "react";
import Layout from "../components/layout";
import Header from "../components/header";
import Block from "../components/block";

// import Image from "gatsby-image";
import "../components/layout.css";
import "../../static/styles/style.css";
import LocationButtons from "../components/location-button";
// const jsonData = require(`../../brands.json`);

const PageTemplate = props => {
  //   var brand = {};
  const { pageContext } = props;
  // const brand = jsonData.filter(
  //   item => item.brandName === pageContext.brandName
  // )[0];

  var brandNameCapitalized = pageContext?.brandName;
  brandNameCapitalized = brandNameCapitalized
    .toLowerCase()
    .split(" ")
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");

  return (
    <Layout brand={pageContext}>
        {/* coverPicture {
          localFile {
            publicURL
          }
        }
        icon {
          localFile {
            publicURL
          }
        }
        logo {
          localFile {
            publicURL
          }
        } */}
      <Header
        siteTitle={pageContext?.brandName}
        logo={pageContext?.icon?.localFile?.publicURL}
        bgColor={pageContext?.brandColor}
      />
      <Block bgColorBw="#000" bgImage={`url(${pageContext?.coverPicture?.localFile?.publicURL})`}>
      
          <h1 style={{ color: "white", opacity: "1", margin: "80px 0 40px 0" }}>
            {pageContext?.brandTag[0].toUpperCase() + pageContext?.brandTag.substring(1)}
          </h1>
          
          <img
          className="block-logo filter-white"
            style={{
              width: "80%",
              maxWidth: "300px",
              textAlign: "center",
              display: "block",
              margin: "0 auto 40px auto"
            }}
            src={pageContext?.icon?.localFile?.publicURL}
          />
      </Block>

      <Block
        bgColor={pageContext?.brandColor} shiftY={"-200px"}>
          <h2 style={{color: "white", textAlign: "center"}}>The {brandNameCapitalized} Story</h2>
          <p style={{maxWidth: "800px", fontSize: "24px", lineHeight: "1.6", margin: "auto", padding: "20px", textAlign: "center", color: "white"}}>{pageContext?.brandStory}</p>
      </Block>
      <Block>
          <div className="order-section" id="Order">
              <LocationButtons brand={pageContext} />
          </div>
      </Block>

      <footer style={{textAlign: "center", padding: "15px"}}>
        © {new Date().getFullYear()}, {brandNameCapitalized}
      </footer>
    </Layout>
  );
};

export default PageTemplate;
